import { render, staticRenderFns } from "./EmitComponent.vue?vue&type=template&id=85d0358e&scoped=true"
import script from "./EmitComponent.vue?vue&type=script&lang=js"
export * from "./EmitComponent.vue?vue&type=script&lang=js"
import style0 from "./EmitComponent.vue?vue&type=style&index=0&id=85d0358e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d0358e",
  null
  
)

export default component.exports